export const SET_LAWS_NPAS_FETCHING = 'SET_LAWS_NPAS_FETCHING';
export const SET_LAWS_NPAS_FETCHING_ERROR = 'SET_LAWS_NPAS_FETCHING_ERROR';
export const SET_LAWS_NPAS = 'SET_LAWS_NPAS';
export const CLEAN_LAWS_NPAS = 'CLEAN_LAWS_NPAS';
export const ABORT_NPAS_REQUEST = 'ABORT_NPAS_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsNPAs/actions.js